import { useNavigate } from "react-router-dom";
import { ApprovalPoliciesPage as ApprovalPoliciesPageView } from "@/components/ApprovalPoliciesPage";

export function ApprovalPoliciesPage() {
  const navigate = useNavigate();
  return (
    <ApprovalPoliciesPageView
      onSupplierClick={(supplierId) => navigate(`/suppliers/${supplierId}`)}
    />
  );
}
